
import { Component, Vue, Prop } from 'vue-property-decorator'
import API from '@/api/index'
import FormatBytesAsset from '@/utils/formatBytesAsset'
import SnakeToCamelCase from '@/utils/snakeToCamelCase'

interface AssetInterface {
    id: number
    name: string
    size: string
    path: string
    previewPath: string
    type: string
    hdDownloadUrl: string
    lowResDownloadUrl: string
}

@Component
export default class Assets extends Vue {
    @Prop() readonly rawUrl?: string
    @Prop() readonly proxyUrl?: string
    @Prop() readonly isRawDownloadReady?: boolean
    @Prop() readonly isProxyDownloadReady?: boolean

    projectId: number = -1
    activeFilter: string = ''
    assets: Array<AssetInterface> = []
    displayElementIndex: number = -1

    get activeAssets() {
        return this.activeFilter ? this.assets.filter(asset => asset.type === this.activeFilter)
            : this.assets
    }

    filterAssets(type: string) {
        this.activeFilter = type
        this.displayElementIndex = -1
    }

    toggleOptions(index: number) {
        this.displayElementIndex = this.displayElementIndex === index ? -1 : index
    }

    async getAssets() {
        const response = await API.GetProjectAssets(this.projectId)
        const assetsList = response.data

        assetsList.forEach(async(elem) => {
            const lastPointOcurrence = elem.name.lastIndexOf('.')
            const hdUrl = await API.GetAssetDownloadUrl({
                name: elem.name,
                size: elem.size || 0,
                type: SnakeToCamelCase(elem.type.name),
                uploadType: '',
                operationName: 'download',
            }, this.projectId)
            const lowResUrl = await API.GetAssetDownloadUrl({
                name: `${elem.name.substring(0, lastPointOcurrence)}_proxy.mp4`,
                size: elem.size || 0,
                type: SnakeToCamelCase(elem.type.name),
                uploadType: 'deliverable',
                operationName: 'download',
            }, this.projectId)
            this.assets.push({
                id: elem.id,
                name: elem.name,
                size: FormatBytesAsset(elem.size),
                path: elem.path,
                previewPath: elem.previewPath,
                type: elem.type.name,
                hdDownloadUrl: hdUrl.data,
                lowResDownloadUrl: lowResUrl.data,
            })
        })
    }

    mounted() {
        this.projectId = Number(this.$route.params.projectId)
        this.getAssets()
        this.activeFilter = 'INTERVIEW_CLIP'
    }
}

